import { j as e } from "./atoms-v218.js";
import { forwardRef as b, useRef as f, useImperativeHandle as M } from "react";
import { CalendarTable as v } from "./atoms-v21019.js";
import { Month as C, MonthLabelContainer as g, ChangeMonthButton as h } from "./atoms-v21020.js";
import { useCalendarContext as R } from "./atoms-v2766.js";
import { CalendarMonthLabel as $ } from "./atoms-v21021.js";
import { getTextCalculationConfig as I } from "./atoms-v21022.js";
import { useTheme as T } from "styled-components";
import { Icon as u } from "./atoms-v217.js";
function H({
  colorTheme: r = "light",
  hideNextButton: n = !1,
  hidePreviousButton: o = !1,
  monthConfig: t,
  onNextClick: l,
  onPreviousClick: s,
  yearValue: a
}, x) {
  const i = f(null), p = f(null), j = T(), { dataManager: d, domBuilder: m } = R(), c = !d.isBatchResolved(t.monthUID, d.lastEndDate);
  return M(
    x,
    () => ({
      get ref() {
        return i.current;
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), /* @__PURE__ */ e.jsxs(
    C,
    {
      "aria-label": `Calendar Month of ${m.text.months[t.value]}`,
      "data-month": t.value,
      "data-year": a,
      ref: i,
      children: [
        /* @__PURE__ */ e.jsxs(g, { children: [
          /* @__PURE__ */ e.jsx(
            h,
            {
              iconOnly: !0,
              $isHidden: o,
              "aria-label": "Previous Month",
              disabled: !s,
              onClick: s,
              variant: "ghost",
              children: o ? null : /* @__PURE__ */ e.jsx(u, { name: "chevron-left" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            $,
            {
              colorTheme: r,
              isLoading: c,
              monthConfig: t,
              textConfig: {
                ...I(j),
                text: `${m.text.months[t.value]} ${a}`
              },
              yearValue: a
            }
          ),
          /* @__PURE__ */ e.jsx(
            h,
            {
              iconOnly: !0,
              $isHidden: n,
              "aria-label": "Next Month",
              disabled: !l,
              onClick: l,
              variant: "ghost",
              children: n ? null : /* @__PURE__ */ e.jsx(u, { name: "chevron-right" })
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(
          v,
          {
            colorTheme: r,
            isLoading: c,
            monthConfig: t,
            ref: p
          }
        )
      ]
    }
  );
}
const U = b(H);
export {
  U as CalendarMonth,
  H as ComponentToForward
};
